module.exports = __webpack_public_path__ + "static/media/dSlider2.2b23ceed.png";